import React, { Component } from 'react';
import styled, { css } from 'styled-components';
import { getTheme } from '../../global/utils';
import Heading from '../text/Heading';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/pro-light-svg-icons';

const SidePanelWrapper = styled.div`
  width: 308px;
  margin-right: -308px;
  transition: transform 0.3s;
  display: flex;
  flex-direction: column;
  ${props =>
    props.panelVisibility === true &&
    css`
      transform: translateX(-308px);
    `};

  .side-panel {
    &__heading {
      padding-left: ${getTheme('padding', 'horizontalL')};
      padding-right: ${getTheme('padding', 'horizontalL')};
      padding-top: ${getTheme('padding', 'verticalPage')};
      padding-bottom: ${getTheme('padding', 'verticalPage')};
      display: flex;
      align-items: baseline;
      > :first-child {
        margin-bottom: 0;
        max-width: calc(100% - 1rem);
      }
    }
    &__close {
      cursor: pointer;
      border: 0;
      margin-left: auto;
      padding: 0;
      font-size: inherit;
      background: transparent;
      color: ${getTheme('textColor', 'alt')};
      svg {
        width: 1rem;
        height: 1rem;
      }
    }

    &__inner {
      flex-grow: 1;
      overflow: auto;
      padding-left: ${getTheme('padding', 'horizontalL')};
      padding-right: ${getTheme('padding', 'horizontalL')};
      padding-bottom: ${getTheme('padding', 'verticalXL')};
    }
  }
`;

class SidePanel extends Component {
  render() {
    return (
      <SidePanelWrapper
        className={this.props.className}
        panelVisibility={this.props.panelVisibility}
      >
        <div className="side-panel__heading">
          <Heading level="heading2">
            <h3>{this.props.panelChartHeading}</h3>
          </Heading>
          <button type="button" onClick={this.props.handleClose} className="side-panel__close">
            <FontAwesomeIcon icon={faTimesCircle} />
          </button>
        </div>
        <div className="side-panel__inner">{this.props.children}</div>
      </SidePanelWrapper>
    );
  }
}

export default SidePanel;



// WEBPACK FOOTER //
// ./src/components/filters/SidePanel.js